import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class GuidedOnboardingMetricsTour extends TourBase {
	get id(): string {
		return TourId.GUIDED_ONBOARDING__METRICS;
	}

	override get stepData(): StepData[] {
		return [
			{
				step: 1,
				direction: Direction.UP,
				attachTo: () => {
					return $('.popular-metrics');
				},
				focusOverlay: {
					show: true,
					offset: {
						left: -24,
						top: -24,
						width: 48,
						height: 24,
					},
				},
			},
			{
				step: 2,
				direction: Direction.DOWN,
				attachTo: () => {
					return $('.onboarding-guided-tour-banner a.continue');
				},
				focusOverlay: {
					show: true,
					el: () => {
						return $('.onboarding-guided-tour-banner');
					},
				},
			},
		];
	}
}
